/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { additionalQuestionUpdate } from '../../axios/additionalQuestionUpdate'
import type {
	AdditionalQuestionUpdateError,
	AdditionalQuestionUpdatePathParams,
	AdditionalQuestionUpdateRequest,
	AdditionalQuestionUpdateResponse,
} from '../../types/AdditionalQuestionUpdate'

export const additionalQuestionUpdateMutationKey = () => [{ url: '/additional-questions/:question' }] as const

export type AdditionalQuestionUpdateMutationKey = ReturnType<typeof additionalQuestionUpdateMutationKey>

export type AdditionalQuestionUpdateVariables = {
	question: AdditionalQuestionUpdatePathParams['question']
	data: AdditionalQuestionUpdateRequest
}

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::update */
export function useAdditionalQuestionUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		AdditionalQuestionUpdateResponse,
		AxiosError<AdditionalQuestionUpdateError>,
		AdditionalQuestionUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: additionalQuestionUpdateMutationKey(),
		mutationFn: ({ question, data }: AdditionalQuestionUpdateVariables) =>
			additionalQuestionUpdate(question, data, config).then(res => res.data),
		...options,
	})
}
